import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const fetchDynamicsData = async ({
  base_coin_id = 1, 
  page = 1,
  top = 100,
  custom_tag_id = null,
  user_assets = false,
  tag_id = null,
  usd = false,
}) => {
  const params = {
    base_coin_id: base_coin_id.toString(),
    page: page.toString(),
    top: top.toString(),
    usd: usd.toString(),
  };

  if(custom_tag_id !== undefined && custom_tag_id !== null) { params['custom_tag_id'] = custom_tag_id.toString(); }
  if(tag_id !== undefined && tag_id !== null) { params['tag_id'] = tag_id.toString(); }
  if(user_assets !== undefined && user_assets !== null) { params['user_assets'] = user_assets.toString(); }

  const query = new URLSearchParams(params).toString();
  const url = `${backendUrl}/api/screener/period-dyn/?${query}`;

  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка сети при получении импульсов: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при получении импульсных данных:', error);
    throw error;
  }
};

export const fetchDynamicsCoinsList = async ({
  period,
  base_coin_id = 1,
  top = 100,
  page = 1,
  custom_tag_id = null,
  user_assets = false,
  page_size = 100,
  tag_id = null,
  usd = false,
}) => {
  const params = {
    period: period.toString(),
    base_coin_id: base_coin_id.toString(),
    top: top.toString(),
    page: page.toString(),
    page_size: page_size.toString(),
    usd: usd.toString(),
  };

  if(tag_id !== undefined && tag_id !== null) { params['tag_id'] = tag_id.toString(); }
  if(custom_tag_id !== undefined && custom_tag_id !== null) { params['custom_tag_id'] = custom_tag_id.toString(); }
  if(user_assets !== undefined && user_assets !== null) { params['user_assets'] = user_assets.toString(); }

  const query = new URLSearchParams(params).toString();
  const url = `${backendUrl}/api/screener/period-dyn/coins/?${query}`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка сети: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    if (error.name === 'AbortError') {
      console.warn('Запрос отменён пользователем:', url);
    } else {
      console.error('Ошибка при загрузке списка монет по импульсу:', error);
    }
    throw error;
  }
};

export const fetchCompareDynamics = async ({ base_coin_id, compare_id, usd }) => {
  const url = `${backendUrl}/api/screener/compare/period-dyn/?base_coin_id=${base_coin_id}&compare_coin_id=${compare_id}&usd=${usd}`;
  try {
    const response = await fetchWithAuth(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Ошибка при получении импульсов');
    }
    return await response.json();
  } catch (error) {
    throw error;
  }
};